import { R } from "@mobily/ts-belt";
import { useRouteContext } from "@tanstack/react-router";
import type {
  GetManualAccessionNumberErrorsQuery,
  GetManualAccessionNumberErrorsQueryVariables,
} from "generated/graphql";
import { useNavSiteStore } from "src/components/nav-layout/site-context/nav-site-store";
import { urqlClient } from "src/gql/urql-provider";
import { getSubdomain } from "src/utils/hooks/subdomain";
import { getManualAccessionNumberErrorsDocument } from "../../graphql";

export const makeValidationReq = async ({
  exogenousAccessionNumber,
  accessionNumberPrefix,
  accessionNumberSuffix,
}: {
  accessionNumberPrefix?: number;
  accessionNumberSuffix?: number;
  exogenousAccessionNumber?: string;
}) => {
  try {
    const subdomain = getSubdomain();
    const activeSite = useNavSiteStore.getState().navSite;

    if (subdomain == null) {
      throw new Error("Could not get valid subdomain");
    }
    if (activeSite == null) {
      throw new Error("Could not get valid active site");
    }
    if (urqlClient == null) {
      throw new Error("Urql client is not initialised");
    }

    const res = await urqlClient
      .query<
        GetManualAccessionNumberErrorsQuery,
        GetManualAccessionNumberErrorsQueryVariables
      >(getManualAccessionNumberErrorsDocument, {
        accessionNumberPrefix,
        accessionNumberSuffix,
        exogenousAccessionNumber,
        organisationSubdomain: subdomain,
        collectionSiteSlug: activeSite.urlSlug,
      })
      .toPromise();

    return R.Ok(res.data?.org?.site?.errors ?? []);
  } catch (error: unknown) {
    return R.Error(
      error instanceof Error
        ? error
        : new Error("Unknown error during makeValidationReq"),
    );
  }
};
